import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

interface WordProps {
  id: string
  text: string
  disabled?: boolean
}

export function AtThePlaceWord({ id, text, disabled = false }: WordProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id, disabled })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    touchAction: 'none',
    whiteSpace: 'normal',
    lineHeight: '1.125rem',
    opacity: isDragging ? 0.8 : disabled ? 0.5 : 1,
    zIndex: isDragging ? 30 : 10
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className={`
        inline-block rounded-lg bg-gray-50 px-3 py-2
        text-primary font-bold uppercase cursor-pointer shadow-sm
        border border-gray-400 select-none text-sm leading-2
        transition-all duration-150
        ${isDragging ? 'ring-2 ring-primary' : ''}
        ${disabled ? 'pointer-events-none' : ''}
      `}
    >
      {text}
    </div>
  )
}

interface GhostWordProps {
  id: string
}

export function AtThePlaceGhostWord({ id }: GhostWordProps) {
  return (
    <div
      className={`
        inline-block rounded-lg bg-gray-50 px-3 py-2
        text-primary font-bold uppercase cursor-pointer shadow-sm
        border border-gray-400 select-none text-sm leading-2
        z-20
      `}
      style={{ whiteSpace: 'normal', lineHeight: '1.125rem' }}
    >
      {id}
    </div>
  )
}
